<template>
  <img
    :src="src"
    :alt="alt"
    :style="{ maxWidth: maxWidth + 'px', maxHeight: maxHeight + 'px' }"
  >
</template>


<script>
export default {
  name: 'LogoWrapper',
  components: { /* Subcomponents */ },
  props: {
    src: { type: String, required: true },
    alt: { type: String },
    maxHeight: { type: Number, default: 100 },
    maxWidth: { type: Number, default: 200 },
  },
  data() {
    return {

    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {

  },
};
</script>
